import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function PrintIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2H6V6H5C3.34315 6 2 7.34315 2 9V15C2 16.6569 3.34315 18 5 18V16C4.44772 16 4 15.5523 4 15V9C4 8.44772 4.44772 8 5 8H19C19.5523 8 20 8.44772 20 9V15C20 15.5523 19.5523 16 19 16V18C20.6569 18 22 16.6569 22 15V9C22 7.34315 20.6569 6 19 6H18V2ZM16 6V4H8V6H16Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 14H6V22H18V14ZM16 20H8V16H16V20Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M17 12C17.5523 12 18 11.5523 18 11C18 10.4477 17.5523 10 17 10C16.4477 10 16 10.4477 16 11C16 11.5523 16.4477 12 17 12Z",
    fill: "currentColor"
  }));
}